import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-zinc-200 bg-white" data-testid="public-footer">
      <div className="max-w-6xl mx-auto px-5 lg:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-xl bg-[#1E3A8A] flex items-center justify-center">
                <Sparkles className="w-4 h-4 text-white" strokeWidth={2.5} />
              </div>
              <span className="font-display font-bold text-lg tracking-tight">SuperZeka</span>
            </div>
            <p className="text-sm text-zinc-600 max-w-sm leading-relaxed">
              LGS, TYT ve AYT sayısal hazırlığında; soruyu açıklayan, takıldığın noktayı
              görünür kılan ve sıradaki öğrenme adımını gösteren yapay zekâ destekli öğrenme asistanı.
            </p>
          </div>

          <div>
            <div className="text-xs font-semibold text-zinc-900 uppercase tracking-wider mb-3">
              Ürün
            </div>
            <ul className="space-y-2 text-sm text-zinc-600">
              <li><a href="/#nasil" className="hover:text-zinc-900">Nasıl Çalışır?</a></li>
              <li><a href="/#dersler" className="hover:text-zinc-900">Dersler</a></li>
              <li><a href="/#planlar" className="hover:text-zinc-900">Planlar</a></li>
              <li><a href="/#sss" className="hover:text-zinc-900">SSS</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs font-semibold text-zinc-900 uppercase tracking-wider mb-3">
              Yasal
            </div>
            <ul className="space-y-2 text-sm text-zinc-600">
              <li><Link to="/gizlilik" className="hover:text-zinc-900" data-testid="footer-privacy">Gizlilik Politikası</Link></li>
              <li><Link to="/kullanim-sartlari" className="hover:text-zinc-900" data-testid="footer-terms">Kullanım Şartları</Link></li>
              <li><Link to="/kvkk" className="hover:text-zinc-900" data-testid="footer-kvkk">KVKK Aydınlatma</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-zinc-100 flex flex-col md:flex-row justify-between gap-3 text-xs text-zinc-500">
          <div>© {new Date().getFullYear()} SuperZeka. Tüm hakları saklıdır.</div>
          <div className="flex items-center gap-4">
            <a
              href="https://emergent.sh"
              target="_blank"
              rel="noopener noreferrer"
              className="text-zinc-500 hover:text-zinc-900 transition-colors"
              data-testid="emergent-attribution"
            >
              Built with Emergent
            </a>
            <span aria-hidden="true">·</span>
            <span>Türkiye&apos;de tasarlandı ve geliştirildi.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
